import type { Permission } from '@repo/contracts';
import { Navigate, Outlet } from 'react-router';

import { APP_ROUTES } from '@/constants/app-routes';
import { selectCan } from '@/store/auth.slice';
import { useAppSelector } from '@/store/store';

interface RequirePermissionProps {
  permission: Permission;
}

/**
 * Turns a page away before it mounts, so it never fires the requests the
 * gateway would refuse. The home route is where a role with nowhere else to
 * go is given a plain page, so this cannot loop.
 */
export function RequirePermission({ permission }: RequirePermissionProps) {
  const allowed = useAppSelector(selectCan(permission));

  if (!allowed) return <Navigate to={APP_ROUTES.home} replace />;

  return <Outlet />;
}
